import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const liveLogin = () => import("@/views/liveLogin.vue");
const liveCourseWare = () => import("@/views/liveCourseWare.vue");

const routes = [
	{
		path: "/",
		redirect: "/liveLogin",
	},
	{
		path: "/liveLogin",
		name: "liveLogin",
		component: liveLogin,
	},
	{
		path: "/liveCourseWare",
		name: "liveCourseWare",
		component: liveCourseWare,
	}
];

const router = new VueRouter({
	mode: "hash",
	routes,
});

// router.beforeEach((to, from, next) => {
// 	if (to.path !== "/login") {
// 		let token = localStorage.getItem("token");
// 		if (!token) {
// 			next("/login");
// 		} else {
// 			next()
// 		}
// 	} else {
// 		next()
// 	}
// });

export default router;
